import * as React from 'react';

function SvgResidentTypeAllSelected(props) {
  return (
    <svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 102 96" {...props}>
      <path
        d="M19 23a2 2 0 012-2h35a2 2 0 012 2v7a2 2 0 01-2 2H21a2 2 0 01-2-2v-7zM51 2a2 2 0 012-2h40a2 2 0 012 2v7a2 2 0 01-2 2H53a2 2 0 01-2-2V2zM22 68h36v7H22z"
        fill="#E4F2EE"
      />
      <path
        d="M32 62a2 2 0 012-2h12a2 2 0 012 2v13a2 2 0 01-2 2H34a2 2 0 01-2-2V62zm-13-7.5A9.5 9.5 0 019.5 64 9.5 9.5 0 010 54.5 9.5 9.5 0 019.5 45a9.5 9.5 0 019.5 9.5z"
        fill="#E4F2EE"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M54 3v5h38V3H54zm-1 8h2v10H21a2 2 0 00-2 2v7a2 2 0 002 2h1v42H10.915c.055-.156.085-.325.085-.5v-9.618c4.534-.719 8-4.646 8-9.382a9.5 9.5 0 00-19 0c0 4.736 3.466 8.663 8 9.382V73.5c0 .175.03.344.085.5H2.5a1.5 1.5 0 000 3h61a1.5 1.5 0 000-3H58v-1h33V11h2a2 2 0 002-2V2a2 2 0 00-2-2H53a2 2 0 00-2 2v7a2 2 0 002 2zm-8 63H35V63h10v11zm3-12v12h7V32H25v42h7V62a2 2 0 012-2h12a2 2 0 012 2zm10 8h30V11H58v59zm-3-46H22v5h33v-5zM16 54.5a6.5 6.5 0 11-13 0 6.5 6.5 0 0113 0zm47-31a1.5 1.5 0 011.5-1.5h4a1.5 1.5 0 010 3h-4a1.5 1.5 0 01-1.5-1.5zm-33 16a1.5 1.5 0 011.5-1.5h4a1.5 1.5 0 010 3h-4a1.5 1.5 0 01-1.5-1.5zM44.5 38a1.5 1.5 0 000 3h4a1.5 1.5 0 000-3h-4zM76 23.5a1.5 1.5 0 011.5-1.5h4a1.5 1.5 0 010 3h-4a1.5 1.5 0 01-1.5-1.5zM44.5 49a1.5 1.5 0 000 3h4a1.5 1.5 0 000-3h-4zM76 34.5a1.5 1.5 0 011.5-1.5h4a1.5 1.5 0 010 3h-4a1.5 1.5 0 01-1.5-1.5zM31.5 49a1.5 1.5 0 000 3h4a1.5 1.5 0 000-3h-4zM63 34.5a1.5 1.5 0 011.5-1.5h4a1.5 1.5 0 010 3h-4a1.5 1.5 0 01-1.5-1.5z"
        fill="#38B2A6"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M43 66.5C43 82.792 56.208 96 72.5 96S102 82.792 102 66.5 88.792 37 72.5 37 43 50.208 43 66.5z"
        fill="#fff"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M50 67.324c0 12.329 9.926 22.323 22.17 22.323 12.245 0 22.171-9.994 22.171-22.323 0-12.33-9.926-22.324-22.17-22.324C59.926 45 50 54.995 50 67.324z"
        fill="#E4F2EE"
      />
      <path
        d="M71.127 74.766h3.135l-4.903-14.092h-3.466L61 74.766h3.027l1.075-3.418h4.951l1.074 3.418zm-3.584-11.397h.068l1.807 5.772h-3.682l1.807-5.772zm8.037 11.397h2.852V60H75.58v14.766zm4.942 0h2.851V60h-2.851v14.766z"
        fill="#38B2A6"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M97.261 77.491l2.127.972c6.323-14.196.81-30.902-12.694-38.463l-1.127 2.035C98.02 49 103.101 64.407 97.262 77.49zM46 79.724C51.073 89.682 61.238 95.96 72.353 96a29.55 29.55 0 0012.103-2.64l-.95-2.146c-13.249 5.952-28.808.435-35.43-12.563L46 79.724z"
        fill="#FFA950"
      />
    </svg>
  );
}

export default SvgResidentTypeAllSelected;
